(() => {
  let currentHome;
  let cleanup = () => {};
  function initialiseNivrale() {
    const home = document.querySelector('[data-nivrale-home]');
    if (!home || home === currentHome) return;
    cleanup();
    currentHome = home;
    const controller = new AbortController();
    const signal = controller.signal;
    const observers = [];
    const ui = JSON.parse(home.querySelector('[data-nivrale-ui]').textContent);
    const mediaConfig = JSON.parse(home.querySelector('[data-nivrale-media]').textContent);
document.documentElement.classList.add('js');
const $ = (selector, root = home) => root.querySelector(selector);
const $$ = (selector, root = home) => [...root.querySelectorAll(selector)];
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const motionButton = $('#motion-toggle');
const media = $('#hero-media');
let paused = false;
let heroVideo;
let returnFocus;

$('.announcement-close').addEventListener('click', () => $('#announcement').remove());
const header = $('#header');
const updateHeader = () => header.classList.toggle('scrolled', window.scrollY > 30);
window.addEventListener('scroll', updateHeader, {passive:true,signal});
updateHeader();

const mobileMenu = $('.mobile-menu');
$$('a', mobileMenu).forEach(link => link.addEventListener('click', () => { mobileMenu.open = false; }));
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && mobileMenu.open) { mobileMenu.open = false; $('summary', mobileMenu).focus(); }
}, {signal});
document.addEventListener('click', event => {
  if (mobileMenu.open && !mobileMenu.contains(event.target)) mobileMenu.open = false;
}, {signal});

if ('IntersectionObserver' in window && !reduced.matches) {
  const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) {entry.target.classList.add('seen');revealObserver.unobserve(entry.target);}
  }), {threshold:0.08, rootMargin:'0px 0px 35px 0px'});
  $$('.section-intro h2,.showcase-heading,.product-intro,.responsibility-head,.offer-copy,.closing-content').forEach(element => {
    element.classList.add('reveal');revealObserver.observe(element);
  });
}

const chapterLinks = $$('.showcase-sidebar a');
const chapters = $$('.showcase');
if ('IntersectionObserver' in window) {
  const chapterObserver = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (!visible.length) return;
    const current = '#' + visible[0].target.id;
    chapterLinks.forEach(link => {
      const active = link.getAttribute('href') === current;
      link.classList.toggle('active', active);
      if (active) link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');
    });
    const activeLink = chapterLinks.find(link => link.classList.contains('active'));
    if (activeLink && window.innerWidth <= 760) {
      const rail = activeLink.parentElement;
      const left = activeLink.offsetLeft - 16;
      if (left < rail.scrollLeft || left + activeLink.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left,behavior:reduced.matches?'instant':'smooth'});
    }
  },{rootMargin:'-120px 0px -45% 0px',threshold:0});
  observers.push(chapterObserver);
  chapters.forEach(chapter => chapterObserver.observe(chapter));
}

const examples = JSON.parse($('[data-nivrale-examples]').textContent);
$$('[data-example]').forEach(button => button.addEventListener('click', () => {
  const item = examples[button.dataset.example];
  $$('[data-example]').forEach(other => {other.classList.toggle('selected',other===button);other.setAttribute('aria-pressed',String(other===button));});
  $('#example-heading').replaceChildren(...item.title.split('\n').flatMap((line,index) => index ? [document.createElement('br'),document.createTextNode(line)] : [document.createTextNode(line)]));
  $('#example-hypothesis').textContent = item.hypothesis;
  $('#example-facts').textContent = item.facts;
  $('#example-step').textContent = item.step;
  $('.example-panel-kicker').textContent = item.number + ' / UNA POSSIBILE SPIEGAZIONE';
  const panel = $('#example-panel');panel.classList.remove('changing');void panel.offsetWidth;panel.classList.add('changing');
}));
const exampleButtons = $$('[data-example]');
exampleButtons.forEach((button,index) => button.addEventListener('keydown', event => {
  let next;
  if (event.key==='ArrowRight') next=(index+1)%exampleButtons.length;
  if (event.key==='ArrowLeft') next=(index+exampleButtons.length-1)%exampleButtons.length;
  if (event.key==='Home') next=0;
  if (event.key==='End') next=exampleButtons.length-1;
  if (next !== undefined) {event.preventDefault();exampleButtons[next].focus();exampleButtons[next].click();}
}));

function syncMotion() {
  media.classList.toggle('motion-paused',paused||reduced.matches);
  $('.dark-method-inner').classList.toggle('motion-paused',paused||reduced.matches);
  motionButton.setAttribute('aria-pressed',String(paused));
  motionButton.replaceChildren(); const motionIcon=document.createElement('span'); motionIcon.setAttribute('aria-hidden','true'); motionIcon.textContent=paused?'▷':'Ⅱ'; motionButton.append(motionIcon,document.createTextNode(' '+(paused?ui.resume:ui.pause)));
  if (heroVideo) { if (paused||reduced.matches||document.hidden) heroVideo.pause();else heroVideo.play().catch(()=>{ $('#video-status').textContent=ui.video_play; }); }
}
motionButton.addEventListener('click',()=>{paused=!paused;syncMotion();});
reduced.addEventListener('change',syncMotion,{signal});
document.addEventListener('visibilitychange',syncMotion,{signal});
syncMotion();

const config = {heroVideo:'',heroVideoMobile:'',heroVideoCaptions:''};
if (config.heroVideo) {
  const video=document.createElement('video');heroVideo=video;
  video.className='hero-video';video.muted=true;video.loop=true;video.playsInline=true;video.preload='metadata';video.poster='./assets/hero-poster.svg';video.setAttribute('aria-label','Video Nivrale: dal problema alla decisione');
  const useMobile=window.matchMedia('(max-width:760px)').matches;
  video.src=useMobile&&config.heroVideoMobile?config.heroVideoMobile:config.heroVideo;
  if(config.heroVideoCaptions){const track=document.createElement('track');track.kind='captions';track.srclang='it';track.label='Italiano';track.src=config.heroVideoCaptions;video.append(track);}
  video.addEventListener('loadeddata',()=>{media.classList.add('video-ready');$('#video-status').textContent=ui.video_ready;syncMotion();});
  video.addEventListener('error',()=>{media.classList.remove('video-ready');video.remove();heroVideo=undefined;$('#video-status').textContent=ui.video_missing;});
  $('#cinema').append(video);
}

const dialog=$('#demo-dialog');
$$('[data-open-demo]').forEach(link=>link.addEventListener('click',event=>{
  if(typeof dialog.showModal!=='function') return;
  event.preventDefault();returnFocus=link;dialog.showModal();
}));
$('.dialog-close').addEventListener('click',()=>dialog.close());
$('#dialog-example').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close();}});
dialog.addEventListener('close',()=>returnFocus?.focus({preventScroll:true}));


const mobileArtDirection = window.matchMedia('(max-width:760px)');
function syncMethodDetails() {
  $$('.method-detail').forEach(detail => { detail.open = !mobileArtDirection.matches; });
}
mobileArtDirection.addEventListener('change', syncMethodDetails,{signal});
syncMethodDetails();

const notesDialog=$('#project-notes');
let notesReturnFocus;
$$('[data-open-notes]').forEach(link=>link.addEventListener('click',event=>{if(typeof notesDialog.showModal!=='function')return;event.preventDefault();notesReturnFocus=link;notesDialog.showModal();}));
$('.project-close').addEventListener('click',()=>notesDialog.close());
notesDialog.addEventListener('close',()=>notesReturnFocus?.focus({preventScroll:true}));


(() => {
  const mobile = window.matchMedia('(max-width:760px)');
  const images = [...home.querySelectorAll('img[data-media-slot]')];
  const fallbacks = new Map(images.map(image => [image, {
    src: image.getAttribute('src'), width: Number(image.getAttribute('width')), height: Number(image.getAttribute('height'))
  }]));
  let revision = 0;
  function sync() {
    const currentRevision = ++revision;
    for (const image of images) {
      const item = mediaConfig[image.dataset.mediaSlot];
      const source = item && (mobile.matches ? item.mobile || item.desktop : item.desktop || item.mobile);
      const fallback = fallbacks.get(image);
      if (!source) {
        image.src = fallback.src; image.width = fallback.width; image.height = fallback.height;
        continue;
      }
      const original = new Image();
      original.onload = () => {
        if (signal.aborted || revision !== currentRevision || !original.naturalWidth) return;
        image.width = original.naturalWidth; image.height = original.naturalHeight; image.src = source;
      };

      original.onerror = () => {};
      original.src = source;
    }
  }
  mobile.addEventListener('change', sync,{signal});
  sync();
})();

    cleanup = () => {controller.abort();observers.forEach(observer=>observer.disconnect());heroVideo?.pause();};
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialiseNivrale,{once:true});
  else initialiseNivrale();
  document.addEventListener('shopify:section:load',initialiseNivrale);
  document.addEventListener('shopify:section:unload',event=>{if(currentHome&&event.target.contains(currentHome)){cleanup();currentHome=undefined;}});
})();
